module.exports = __webpack_public_path__ + "static/media/BG_18.028630a2.png";